import styled from "styled-components";

const GaugeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 22vw; /* responsive width */
  max-width: 120px; /* cap size */
  min-width: 80px; /* avoid being too small */
  aspect-ratio: 1; /* maintain circle shape */
`;

export function CircularGauge({ value, label }) {
  const radius = 30;
  const stroke = 5;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (value / 100) * circumference;

  // Get stroke color based on thresholds
  const getColor = (v) => {
    if (v < 30) return "blue";
    if (v > 85) return "red";
    return "green";
  };

  return (
    <GaugeContainer>
      <svg viewBox="0 0 100 100" width="100%" height="100%">
        <defs>
          <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow
              dx="-1"
              dy="3"
              stdDeviation="2"
              floodColor="rgba(51, 49, 49, 0.5)"
            />
          </filter>

          <linearGradient id="gaugeStrokeGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.25" />
            <stop offset="50%" stopColor={getColor(value)} stopOpacity="1" />
            <stop offset="100%" stopColor="#464444" stopOpacity="0.3" />
          </linearGradient>
        </defs>

        <circle
          stroke="url(#gaugeStrokeGradient)"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          r={normalizedRadius}
          cx="50"
          cy="50"
          transform="rotate(-90 50 50)"
          filter="url(#dropShadow)"
        />

        <text
          x="50%"
          y="45%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={getColor(value)}
          fontSize="0.6em"
          fontWeight="bold"
        >
          {Math.round(value)}%
        </text>
        <text
          x="50%"
          y="60%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill="#c2c2c2"
          fontSize="0.56em"
        >
          {label}
        </text>
      </svg>
    </GaugeContainer>
  );
}
